import React, { useState } from "react";

import Modal from "../ui/Modal";
import Button from "../ui/Button";
import { FileText, Copy } from "lucide-react";
import { toast } from "react-toastify";

const SummaryCell = ({ text }) => {
  const [open, setOpen] = useState(false);

  const handleCopy = async () => {
    if (!text) {
      toast.warning("No text to copy");
      return;
    }
  
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Copied to clipboard");
    } catch (error) {
      toast.error("Failed to copy summary");
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <div className="summary-cell" onClick={() => setOpen(true)}>
        <span className="summary-icon-container">
          <FileText size={14} className="summary-icon" />
        </span>
        <span className="summary-text">
          {text}
        </span>
      </div>

      {/* Modal */}
      <Modal
  title="Full Summary"
  isOpen={open}
  onClose={handleClose}
 
>
<div className="summary-modal-content">
  <div className="summary-text-box">
    {text}
  </div>
</div>
  </Modal>
    </>
  );
};


export default SummaryCell;